import { render, staticRenderFns } from "./ObjectiveEffects.vue?vue&type=template&id=ea0e0704&"
import script from "./ObjectiveEffects.vue?vue&type=script&lang=js&"
export * from "./ObjectiveEffects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports